import axios from 'axios';
import { defineStore } from 'pinia';
import { authStore } from './auth';

export const subscriptionStore = defineStore('subscription-store', {
    state: () => {
        return {
            allSubscriptions: [],
        };
    },

    getters: {
        subscriptions(state) {
            return state.allSubscriptions;
        },
    },

    actions: {
        async fetchSubscriptions() {
            try {
                const response = await axios.get(
                    process.env.VUE_APP_API_BASE_URL +
                        'applicants/me/subscriptions',
                    authStore().authConfig
                );
                this.allSubscriptions = response.data;
                return true;
            } catch (err) {
                this.allSubscription = [];
                console.error('error loading subscriptions: ', err);
                return err;
            }
        },
    },
});
